<template>
  <div class="problem">
    <md-field v-if="list.length>0">
      <md-cell-item  v-for="(item,index) in list" :key="index " arrow @click="onClick(item.id)" :title="item.title" :no-border="index==list.length?true:false"/>
    </md-field>
    <noth-modal v-else></noth-modal>
  </div>
</template>

<script>
import { Field, CellItem, Icon } from 'mand-mobile'
import NothModal from '../Modal/NothModal'

export default {
  name: 'problem',
  components: {
    [Field.name]: Field,
    [CellItem.name]: CellItem,
    [Icon.name]: Icon,
    // eslint-disable-next-line vue/no-unused-components
    NothModal
  },
  data () {
    return {
      scrollheight: {
        height: document.documentElement.clientHeight + 'px'
      },
      list: []
    }
  },
  activated () {
    this.getList()
  },
  methods: {
    onClick (id) {
      window.location.href='/res/appservice/m/article/index.html?id='+id+'&type=2'
      // this.$router.push({
      //   name: 'Parse',
      //   query: {
      //     id: id,
      //     type: '1'
      //   }
      // })
    },
    getList () {
      const par = {
        countryId: this.$route.query.id,
        shopCode: JSON.parse(localStorage.getItem("shopkey")).appCode
      }
      this.http.APIASK(this.ports.normalQuestion, 'get', par).then(res => {
        this.list = res
      })
    }
  }
}
</script>

<style lang="less">
  .problem{
    .md-field{
      padding: 0 0.4rem;
    }
    .md-cell-item-content{
      text-align: left;
    }
    .md-cell-item-body:before{
      content: "";
      position: absolute;
      z-index: 2;
      -webkit-transform: scaleY(.5) translateY(100%);
      transform: scaleY(.5) translateY(100%);
      bottom: 0;
      left: 0;
      right: auto;
      top: auto;
      width: 100%;
      border-bottom: 0.02rem solid #e2e4ea;
      -webkit-transform-origin: 50% 100%;
      transform-origin: 50% 100%;
    }
  }

</style>
